import React from 'react';
import PropTypes from 'prop-types';

import PlayerBookmark, { ICON_SIZE } from '.';
import { useSavedPlayerStatus, useRegisterSavedPlayerIds } from '../SavedPlayerStatusProvider';

// Profile-header bookmark bound to the page-scoped SavedPlayerStatusProvider so it shares one saved-status
// source with the Verified Rankings leaderboard: it registers the profile id for the shared batch, reads
// isSaved / savedListIds / isLoading back from the provider, and routes save/remove through the same
// handler — so saving here fills the matching leaderboard row (and the reverse) with no reload. Renders
// nothing until the SAVED_PLAYER_LIST_ROLLOUT gate is on, mirroring the row bookmark's flag gating.
const HeaderPlayerBookmark = (props) => {
    const { playerId, playerName, className, size, 'data-testid': dataTestId } = props;
    const { gateEnabled, getRowStatus, handleSaveSuccess, handleRemoveSuccess } = useSavedPlayerStatus();

    useRegisterSavedPlayerIds(playerId != null ? [playerId] : []);

    if (!gateEnabled) {
        return null;
    }

    const { isSaved, savedListIds, isLoading } = getRowStatus(playerId);

    return (
        <PlayerBookmark
            playerId={playerId}
            playerName={playerName}
            isSaved={isSaved}
            isLoading={isLoading}
            savedListIds={savedListIds}
            onSaveSuccess={() => handleSaveSuccess(playerId)}
            onRemoveSuccess={() => handleRemoveSuccess(playerId)}
            variant="header"
            className={className}
            size={size}
            data-testid={dataTestId}
        />
    );
};

HeaderPlayerBookmark.propTypes = {
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    playerName: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.number,
    'data-testid': PropTypes.string,
};

HeaderPlayerBookmark.defaultProps = {
    playerId: null,
    playerName: null,
    className: null,
    size: ICON_SIZE,
    'data-testid': null,
};

export default HeaderPlayerBookmark;
